import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import ExpensesDetail from '../../../components/expenses-detail';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';

import Header2 from '../../../components/headers/header2';
import {Row} from '../../../components/layout';
import ModalTemplate from '../../../components/modal';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import {getDocuments, getDocumentsForDownload} from '../../../util/utility';
import ReimbursementListItemStatus from '../../reimbursements/reimbursement-history/components/ReimbursementListItemStatus';
import {UtilizationItem} from '../UtilizationHistory';

interface UtilizationDetailProps {
  user: any;
  showModal: boolean;
  setShowModal(value: boolean): void;
  labels: typeof strings.pt.insuranceHistory;
  selectedItem: UtilizationItem | undefined;
  expenses: Expense[];
  color: string;
  stateDescription: string;
  selectedBu: any;
}

interface IDocsForDownload {
  documentsAttached: any[];
  documentsEmitted: any[];
}

function UtilizationDetail({
  showModal,
  setShowModal,
  labels,
  selectedItem,
  expenses,
  selectedBu,
  user,
  color,
  stateDescription,
}: UtilizationDetailProps) {
  // Current way of checking if the item was sent by the user is by checking if the submittedGroup contains "MEMB" or "ČLAN"
  // because the submittedGroup is the only field that contains the constistent information about who sent it (Stupidly enough).
  // This is not ideal, but it's a workaround until we have a better way of checking this.
  // "MEMB" - for Portuguese and English language
  // "ČLAN" - for Serbian language
  const sentByMe =
    selectedItem?.submittedGroup?.toUpperCase().includes('MEMB') ||
    selectedItem?.submittedGroup?.toUpperCase().includes('ČLAN');

  const [listOfDocuments, setListOfDocuments] = useState<any>();
  const [listOfDocumentsAttached, setListOfDocumentsAttached] = useState<any>();
  const [listOfDocumentsEmitted, setListOfDocumentsEmitted] = useState<any>();

  useEffect(() => {
    if (selectedItem?.auditNbr) {
      getDocuments(
        selectedBu,
        selectedItem,
        'utilizationHistory',
        setListOfDocuments,
      );
    }
  }, []);

  useEffect(() => {
    const result: IDocsForDownload = getDocumentsForDownload(listOfDocuments);

    if (result.documentsEmitted.length > 0) {
      setListOfDocumentsEmitted(result.documentsEmitted);
    } else {
      setListOfDocumentsEmitted(undefined);
    }
    if (result.documentsAttached.length > 0) {
      setListOfDocumentsAttached(result.documentsAttached);
    } else {
      setListOfDocumentsAttached(undefined);
    }
  }, [listOfDocuments]);

  return (
    <ModalTemplate
      className="reimbursement-detail-modal"
      show={showModal}
      onHide={() => setShowModal(false)}
      cross={true}
      hideFooter={true}>
      <Header2
        style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
        className="reimbursement-history-modal-header">
        {labels?.insuranceHistory_title}
      </Header2>
      {sentByMe ? (
        <Row className="reimbursement-history-modal-subtitle">
          <Row
            className="reimbursement-history-modal-sent"
            style={{...fonts.M, color: '#9C9C9C'}}>
            {labels?.insuranceHistory_sendBy}
          </Row>
          <Row
            style={{...fonts.ML}}
            className="reimbursement-history-modal-status">
            <ReimbursementListItemStatus
              stateDescription={stateDescription}
              color={color}
            />
          </Row>
        </Row>
      ) : (
        <Row></Row>
      )}
      <ExpensesDetail
        listOfDocumentsAttached={listOfDocumentsAttached}
        listOfDocumentsEmitted={listOfDocumentsEmitted}
        estadoId={selectedItem?.statusId}
        process={selectedItem?.auditNbr}
        selectedPatient={`${user.name}`}
        occorenceDate={selectedItem?.dosFrom}
        expenses={expenses}
        provider={selectedItem?.providerName}
        submittedFiles={[]}
        type={selectedItem?.network.toUpperCase()}
        selectedItem={selectedItem}
      />
    </ModalTemplate>
  );
}

const mapStateToProps = ({strings, user, selectedBu}: any) => ({
  labels: strings.value.pt.insuranceHistory,
  user: user.value,
  selectedBu: selectedBu.value,
});

export default compose(connect(mapStateToProps)(UtilizationDetail));
